import { forwardRef, useRef } from 'react';
import ReactQuill from 'react-quill';
import { sanitizeTextBlockHtml } from 'src/components/elements/formats/SafeHTMLRender';

type SafeReactQuillProps = Omit<ReactQuill.ReactQuillProps, 'value'> & { value: string };

/**
 * Quill 1 loads HTML through innerHTML on a live element, so stored markup would run its handlers
 * there: every value the editor did not emit itself is sanitized first. The editor's own output
 * goes back unchanged — react-quill resets the editor whenever the value differs from it.
 */
const SafeReactQuill = forwardRef<ReactQuill, SafeReactQuillProps>(({ value, onChange, ...props }, ref) => {
    const emitted = useRef<string>();
    return (
        <ReactQuill
            {...props}
            ref={ref}
            value={value === emitted.current ? value : sanitizeTextBlockHtml(value)}
            onChange={(html, delta, source, editor) => {
                emitted.current = html;
                onChange?.(html, delta, source, editor);
            }}
        />
    );
});

export default SafeReactQuill;
